
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    Slide,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        RecordModel,
        ActionModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";
import CloseIcon from "@mui/icons-material/Close";
import {ConnectEmailComponent} from "./ConnectEmail";


export const ActionComponent: React.FC<{
  selectedAction: ActionModel,
  data: any
}> = ({
  selectedAction,
  data
}) => {

  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();


  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  useEffect(() => {
    if(data){
      setOpenDialog(true)
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps


  const onCloseDialog = (event: any) => {
    setOpenDialog(false)
  }


return (
    <Dialog
      open={openDialog}
      onClose={onCloseDialog}
      fullWidth
      maxWidth={'lg'}
      TransitionComponent={Slide}
      TransitionProps={{direction: "up"} as any}
      PaperProps={{
          sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '70vh'
          }
        }}
    >

    <DialogTitle>
      <Toolbar sx={{justifyContent: 'space-between'}}>
        <Typography variant="h6">
          {selectedAction.Label_sys}
        </Typography>

        <IconButton
           edge="start"
           color="inherit"
           onClick={onCloseDialog}
           aria-label="close"
       >
         <CloseIcon />
       </IconButton>
     </Toolbar>
    </DialogTitle>

    <Box sx={{height: '100%'}}>

    {selectedAction.OnSuccess_sys.component === "<ConnectEmail>" &&
     <DialogContent>
       <ConnectEmailComponent
          data={data}
       />
     </DialogContent>
    }




    </Box>
    </Dialog>

  );

};
